import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { AccessControlWrapper } from "../../components";

export default function AccessControlPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <AccessControlWrapper organization={organization} />
    </ModalProvider>
  );
}
